import m from "../../geodata/es2015/maldivesIslandsLow";
window.am4geodata_maldivesIslandsLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/maldivesIslandsLow.js
// module id = null
// module chunks = 